module.exports = __webpack_public_path__ + "img/1440.519d6fd4.svg";